import {
  addHtmlElementEventListener,
  appendHtmlElementChild,
  downloadServerPdf,
  enableHtmlElement,
  getHtmlElement,
  removeHtmlChildren,
  renderWebComponent,
  string2obj
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import I18n from "i18n-js";


export class PdfGeneratorComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
  }

  connectedCallback() {
    addHtmlElementEventListener(this.shadowRoot, 'printButton', 'click', () => this.downloadServerPDFFile())
  }


  // Funzione che aggiorna il layout del bottone di download del pdf quando parte il download vero e proprio dei dati
  startLoadingData() {
    enableHtmlElement(this.shadowRoot, 'printButton', false);
    removeHtmlChildren(getHtmlElement(this.shadowRoot, 'printButton'));

    const row = document.createElement('template');
    row.innerHTML = `
      <div class="d-flex align-items-center text-center">
        <div class="spinner-border text-white ml-2" role="status"></div>
        <p class="ml-2 text-nowrap text-white mb-0">
          ${I18n.t('js.PDFGenerator.submissionList.loadingData').toUpperCase()}
        </p>
      </div>
    `

    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'printButton'), row.content.cloneNode(true));
  }


  // Funzione che aggiorna il layout del bottone di download del pdf quando termina il download dei dati
  endLoadingData() {
    enableHtmlElement(this.shadowRoot, 'printButton', true);
    removeHtmlChildren(getHtmlElement(this.shadowRoot, 'printButton'));

    const row = document.createElement('template');
    row.innerHTML = `
      ${
        this.props.displayDownloadIcon ?
          `<img src="/images/icons/white/download-pdf.svg"
               alt="" width="30" height="30"
               class="mr-1"
          >
            ${this.props.generatorText}`
        :
          `${this.props.generatorText}`
      }
    `

    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'printButton'), row.content.cloneNode(true));
  }


  // Funzione che scarica un pdf generato dal server (Prawn)
  downloadServerPDFFile() {
    if (this.props.displayDownloadIcon || this.props.displaySpinner)
      this.startLoadingData();

    downloadServerPdf(this.props.pdfUrl)
      .catch((error) => console.error("ERROR:", error))
      .finally(() => {
        if (this.props.displayDownloadIcon || this.props.displaySpinner)
          this.endLoadingData();
      });
  }



  render() {
    const html = `              
      ${
        this.props.type === 'button' ?
          `
            <button
              type="button"
              id="printButton"
              class="${this.props.cssClassList}"
            >
              ${
                this.props.displayDownloadIcon ? 
                  `<img src="/images/icons/white/download-pdf.svg" 
                    alt="" width="25" height="25"
                    class="mr-1"
                  >`
                :
                  ``
              }
              ${this.props.generatorText}
            </button>
          `
        :
          `<span class="text-aiBlue text-underline-imp cursor-pointer" >
            ${this.props.generatorText}
          </span>`
      }
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles]);
  }
}

window.customElements.define("pdf-generator-component", PdfGeneratorComponent);